import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery, AppBar, Box, Toolbar } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { Outlet, useLocation } from "react-router-dom";
 
// import Header from "./Header";
import Sidebar from "../components/screens/admin/Sidebar";
import Header from "../components/screens/admin/Header";
import Footer from "../components/screens/admin/Footer";
// import { toggleDrawer, openDrawer, closeDrawer } from "../../redux/drawerSlice.js";
// import { drawerWidth } from "config.js";
// import useDrawerControl from "../../hooks/useDrawerControl.js";
 
const Main = styled((props) => <main {...props} />)(({ theme }) => ({
  width: "100%",
  minHeight: "100vh",
  flexGrow: 1,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));
 
const OutletDiv = styled((props) => <div {...props} />)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(3),
  },
  padding: theme.spacing(5),
}));
 
const MainLayout = () => {
 const theme = useTheme();
 const [activeView, setActiveView] = useState("agents");
 const location = useLocation();


   // ❌ List of routes where Sidebar + Header should NOT appear
   const noLayoutRoutes = [
    "/admin/agent-data", // base path
  ];

  const hideLayout = noLayoutRoutes.some((route) =>
    location.pathname.startsWith(route)
  )

  return (
    <Box sx={{ display: "flex", width: "100%", minHeight:"30px" }}>
       
        {!hideLayout && (
        <Sidebar activeView={activeView} onViewChange={setActiveView} />
      )}
      <Main>
      
        {!hideLayout && <Header />}
        <OutletDiv sx={{ px: 2, py: 1 }}>
          <Outlet />
        </OutletDiv>
        {!hideLayout && <Footer />}
      </Main>
    </Box>
  );
};
 
export default MainLayout;
 
 